import React from 'react'
import Loader from '../Loader'
import NoDataAvailable from '../NoDataAvailable'
import InfiniteScrollData from './InfiniteScrollData'
import useFavoriteGames from 'hooks/useFavoriteGames'
import { useSelector } from 'react-redux'

const FavoriteGrid = ({ selectedLanguageCode, languageData }) => {
  const { favoriteGamesList, toggleFavorite } = useFavoriteGames()
  const { favLoading = false } = useSelector((state) => state?.casinoMenu)

  if (favLoading) {
    return (
      <div className='fav-loader'>
        <Loader top='7%' />
      </div>
    )
  }

  if (!favoriteGamesList?.count) {
    return (
      <div className='text-center mt-4 mb-3'>
        <NoDataAvailable errorMessage={languageData?.casinoNoFavGamesFound} />
      </div>
    )
  }

  return (
    <div className='games-grid-wrapper'>
      <div className='games-grid'>
        <InfiniteScrollData
          games={favoriteGamesList}
          toggleFavorite={toggleFavorite}
          selectedLanguageCode={selectedLanguageCode}
          favoriteGamesList={favoriteGamesList}
        />
      </div>
    </div>
  )
}

export default React.memo(FavoriteGrid)
